import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deletePartidaCategory,
	getPartidaCategories,
} from "../../../../api/partidaCategory";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import PartidaCategoryContent from "./PartidaCategoryContent";

function getData(categories) {
	let data = [];
	for (let i = 0; i < categories.length; ++i) {
		const elem = {};
		const category = categories[i];

		elem.descripcion = category?.descripcion;
		elem.referencia = category?.referencia;
		elem.id = category?.id;

		data = data.concat(elem);
	}
	return data;
}

export default function PartidasCategoriesPage() {
	const [data, setData] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openCategoryInfoDialog, setOpenCategoryInfoDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push(
								"/categorias-partidas/" + cell + "/edit"
							);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedCategory(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{
			dataField: "referencia",
			text: "Referencia",
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getPartidaCategories(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las categorías.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Categorías de partidas">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() =>
								history.push("/categorias-partidas/edit")
							}
						>
							Nueva categoría
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(data)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const category = data?.find(
									(x) => x.id === row.id
								);
								setSelectedCategory(category);
								setOpenCategoryInfoDialog(true);
							},
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar esta categoría de partida?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deletePartidaCategory(
								selectedCategory?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminado!",
											customMessage:
												"Proveedor eliminado con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar el proveedor.",
									});
								});
						}}
					/>
					<EntityInfoDialog
						title={"Categoría: " + selectedCategory?.descripcion}
						open={openCategoryInfoDialog}
						setOpen={setOpenCategoryInfoDialog}
						content={
							<PartidaCategoryContent
								category={selectedCategory}
							/>
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
